class searchInput {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("searchInput::initialize()")

		this.searchInputs = document.querySelectorAll(".bb-search-input__search-input")

		this.searchInputs.forEach((item) => {
			item.addEventListener("input", (event) => {
				this._handleInputChanges(event)
			})
		})
	}

	_handleInputChanges(event) {
		const searchInput = event.currentTarget
		const searchForm = searchInput.closest(".bb-search-input__form")
		const searchFormSubmitButton = searchForm.querySelector(".bb-search-input__submit")

		if (searchInput.value === "") {
			searchForm.classList.remove("bb-search-input__form--active")
			searchFormSubmitButton.disabled = true
		} else {
			searchForm.classList.add("bb-search-input__form--active")
			searchFormSubmitButton.disabled = false
		}
	}
}

export default searchInput
